/*
* @Author: GX
* @Date:   2018-05-17 17:06:30
* @Last Modified by:   GX
* @Last Modified time: 2018-05-17 17:27:17
*/
import { getHttpInstance } from './base';
import createInstance from './instanceCreator';
import { resultAdapter } from '@/helper/http';

export const checkLoginStatus = token => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/user/checkLoginStatus?token=${token}`);
};
// 登出
export const logout = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/logout`);
};

// 高德搜索
export const getGdSearchList = ({keywords}) => {
  const httpInstances = createInstance();
  httpInstances.interceptors.response.use(resultAdapter);
  return httpInstances.get(`https://restapi.amap.com/v3/assistant/inputtips?key=42da6bb894bd02ac87e8acbe6bc06dee&keywords=${keywords}`);
};

// 高德通过IP
export const getAddress = ({location}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getAddress`, {location});
};

// 速递易
export const getSdyBoxInfo = ({latitude, longitude}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/sdy/getBoxList`, {latitude, longitude});
};

// 丰巢
export const getFcBoxInfo = ({latitude, longitude}) => {
  latitude = parseFloat(latitude).toFixed(6);
  longitude = parseFloat(longitude).toFixed(6);
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/fengChao/getBoxList`, {latitude, longitude});
};

// 获取当前系统时间
export const getSystemTime = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getSystemTime`);
};

// 获取最新参与的用户列表
export const getActivityTime = ({type = ''}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/getTime`, {type});
};
// 获取最新参与的用户列表
export const getUserJoinList = ({type}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/getUserList`, {type});
};

// 保存用户手机号
export const opSavePhone = ({uid, tel, type}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/savePhone`, {uid, tel, type});
};

// 判断是否参加过活动
export const opCheckStatus = ({token, type}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/checkStatus`, {token, type});
};

// 获取开奖结果的用户手机号
export const opPrizeResult = ({type = ''}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/prizeResult`, {type});
};

// 注销账户
export const cancelAccount = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(
    `${httpInstances.apiHost}/api/user/cancelAccount`
  );
};

// 查询用户账号注销申请状态 注销申请状态 0 未申请 1 已申请
export const getCancelAccountStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(
    `${httpInstances.apiHost}/api/user/getCancelAccountStatus`
  );
};

// 422--618活动 领取优惠券或券包
export const getActivityAddByUser = ({ id, isCouponParcel = 0, couponInfoShow = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/addByUser`, {id, isCouponParcel, couponInfoShow});
};

// 获取当日可领取状态和系统时间
export const couponInfoShow = ({ id, isCouponParcel = 0 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/endStatusGet`, {id, isCouponParcel});
};
// 获取地址名称
export const getAddrName = ({ addrId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/getAddrName`, {addrId});
};
// 获取当前城市是否有门店(到店回收)
export const getCityStoreInfo = ({ latitude = -1, longitude = -1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/xianyu/getCityStoreInfo`, {latitude, longitude});
};
// 获取门店城市列表(到店回收)
export const getCityList = ({ cityId, latitude = -1, longitude = -1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/xianyu/getCityList`, {cityId, latitude, longitude});
};
// 获取小店列表(到店回收)
export const getStoreList = ({ areaId, latitude = -1, longitude = -1, pageIndex = 1, pageSize = 10 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/xianyu/getStoreList`, {areaId, latitude, longitude, pageIndex, pageSize});
};
// 获取门店详情(到店回收)
export const getStoreInfo = ({ storeId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/xianyu/getStoreInfo`, {storeId});
};
// 获取门店下单的时间段(到店回收)
export const getStoreTime = ({ storeId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/xianyu/getStoreTime`, {storeId});
};
// 获取分享详情（好友分享加价）
export const getShareInfo = ({ shareId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/activity/getShareInfo`, {shareId});
};
// 给自己助力（好友分享加价）
export const helpMyself = ({ shareId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/activity/shareCallback`, {shareId});
};
// 用户行为上报
export const openBehavior = ({ fromPid = '', storeId = '', clerkId = '', event, openid, unionid, tempNo }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/open/behavior`, { fromPid, storeId, clerkId, event, openid, unionid, tempNo });
};

// 支付宝寄卖竞拍详情
export const getAlipayJimaiAuction = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/BangmaiV2/Sales/productDetail`, params);
};
// 支付宝寄卖质检报告
export const getAlipayJimaiReport = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/BangmaiV2/order/getReportInfo`, params);
};
// 下单接口（百度圣诞活动）
export const createBdOrder = ({ userName, tel, address, time, province, city, county, regionId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/baidu/placeOrder`, { userName, tel, address, time, province, city, county, regionId });
};
// 我的福袋列表（百度圣诞活动）
export const getLuckyBag = ({ pageIndex = 1, pageSize = 20 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/baidu/getOrderList`, { pageIndex, pageSize });
};
// 批量下单（大扫除活动）
export const createBatchOrder = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/batch/placeOrder`, params);
};
// 领取红包（大扫除活动）
export const receive = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/batch/receive`, params);
};
// 查看可以领取的红包列表（大扫除活动）
export const getBatchRewardList = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/batch/getRewardList`, params);
};
// 下单结果（大扫除活动）
export const getBatchOrderResult = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/batch/getOrderResult`, params);
};
// 获取奖品列表（年货）
export const getYearProductList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/getGiftList`);
};
// 获取估价结果（年货）
export const getYearEvaluateResult = ({ evaluateid, type = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/getEvaluateResult`, { evaluateid, type });
};
// 下单接口（年货）
export const createYearOrder = ({ evaluateId, giftId, userName, tel, address, time, province, city, county, regionId, payName, payAccount, type }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/placeOrder`, { evaluateId, giftId, userName, tel, address, time, province, city, county, regionId, payName, payAccount, type });
};
// 获取下单结果（年货）
export const getYearOrderResult = ({ orderNum }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/getOrderDetail`, { orderNum });
};
// 获取订单列表（年货）
export const getYearOrderList = ({ pageIndex = 1, pageSize = 20 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/getOrderList`, { pageIndex, pageSize });
};
// 取消订单（年货）
export const cancelYearOrder = ({ orderNum, reason }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/year/cancel`, { orderNum, reason });
};
// 获取答题列表（测一测）
export const getIdeaAnswerList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/question/getQuestionList`);
};
// 提交答题答案（测一测）
export const sendIdeaAnswer = ({ ids, options }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/question/submit`, { ids, options });
};
// 获取微信用户信息（测一测）
export const getIdeaUserInfo = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getOauthInfo`, params);
};
// 查看答题结果（测一测）
export const getIdeaAnswerResult = ({ resultId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/question/getQuestionResult`, { resultId });
};
// 查看优惠券列表（测一测）
export const getIdeaAnswerCouponList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/getGiftList`);
};
// 兑换优惠券（测一测）
export const getIdeaAnswerUserCoupon = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/exchange`, params);
};
// 查看奖品详情（测一测）
export const getIdeaAnswerGiftDetails = ({ recordId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/getGiftInfo`, { recordId });
};
// 获取礼品劵列表（测一测）
export const getIdeaAnswerGiftList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/getPrizeList`);
};
// 领取礼品劵（测一测）
export const getIdeaAnswerUserGift = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/receive`, params);
};
// 领取判断实物劵领取资格（测一测）
export const getIdeaAnswerGiftStatus = ({ recordId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v1/gift/getQualifications`, { recordId });
};
// 查询剩余可以抽奖的次数（2020618活动）
export const getLuckWheelNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/getLeftNum`);
};
// 抽奖（2020618活动）
export const getLuckWheel = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/luck`);
};
// 兑奖（2020618活动）
export const exchangePrize = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/exchange`, params);
};
// 分享加抽奖次数（2020618活动）
export const addWheelNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/shareCallback`);
};
// 获取中奖用户列表（2020618活动）
export const getRollingList = (type = 1) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/getRollingList`, { type });
};
// 获取用户奖品列表（2020618活动）
export const getUserPrizeList = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/getPrizeUserList`, params);
};
// 奖品订单详情（2020618活动）
export const getPrizeOrderInfo = ({ orderNum }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prize/getOrderInfo`, { orderNum });
};
// 批量下单（2020618-多台下单活动）
export const createBatchMoreOrder = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/batch/placeOrder`, params);
};
// 批量下单（2020618-多台下单活动）
export const createBatchMoreOrderAsyn = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/batch/placeOrderAsyn`, params);
};
// 领取红包（2020618-多台下单活动）
export const getReceive = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/batch/receive`, params);
};
// 查看可以领取的红包列表（2020618-多台下单活动）
export const getBatchReward = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/batch/getRewardList`, params);
};
// 查看排行榜（2020618-排行榜）
export const getBatchRank = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/batch/getRankList`, params);
};
// 参与活动权限（sns
export const getSnsJoinStatus = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/getJoinInfo`, params);
};
// 分享活动详情（sns
export const getSnsActivityInfo = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/getShareInfo`, params);
};
// 查询助力状态（sns
export const getSnsHelpStatus = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/getAssistInfo`, params);
};
// 参与助力（sns
export const assistSns = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/assist`, params);
};
// 分享回调（sns
export const getSnsShareCallback = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/shareCallback`, params);
};
// 分享轮播列表（sns
export const getSnsShareLoop = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/sns/getRollingData`, params);
};
// 查询剩余可以抽奖的次数（2020625活动）
export const getDragonLuckWheelNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/getLeftNum`);
};
// 抽奖（2020625活动）
export const getDragonLuckWheel = ({ longitude = '-1', latitude = '-1' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/luck`, { longitude, latitude });
};
// 获取奖品列表（2020625活动）
export const getDragonPrizeList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/getPrizeList`);
};
// 分享、估价加抽奖次数|引导用户的行为（2020625活动）
export const addNumAndAction = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/shareCallback`, params);
};
// 根据机器品牌码和spu机器码获取产品信息（vivo）
export const getLocalModel = ({ brand, model }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/product/getLocalModel`, { brand, model });
};
// 首页历史估价、估本机
export const getEvaluateHistoryTop = ({ brand, model }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/product/getEvaluateHistoryTop`, { brand, model });
};
// 查询用户注销前信息
export const checkAccountBeforeOut = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/user/cancelAccountForCondition`);
};
// 注销用户账号信息
export const cancelUserAccount = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/user/cancelAccount`);
};
// 获取到店、顺丰、上门（新）
export const getAllTimes = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/optimize/getServiceTime`);
};
// 获取回收宝验机地址
export const getDeliveryAddress = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getDeliveryAddress`);
};
// 获取验证码（通用H5物流）
export const getNewSmsCode = ({ tel, imgCode = '' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/common/sendSmsCode`, { tel, imgCode });
};
// 校验验证码（通用H5物流）
export const getVerifySmsCode = ({ tel, smsCode }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/common/verifySmsCode`, { tel, smsCode });
};
// 更新物流单号（通用H5物流）
export const updateTrackingNo = ({ cToken, orderNumber, expressNumber, company }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/updateTrackingNo`, { cToken, orderNumber, expressNumber, company });
};
// 物流详情（通用H5物流）
export const getNewRouteInfo = ({ cToken, orderNumber, expressNumber }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/getRouteInfo`, { cToken, orderNumber, expressNumber });
};
// 物流列表（通用H5物流）
export const getOrderListOnRoad = ({ cToken = '', pageIndex }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/getOrderListOnRoad`, { cToken, pageIndex });
};
// 订单列表（通用H5物流）
export const getNewOrderList = ({ cToken = '', pageIndex }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/getOrderList`, { cToken, pageIndex });
};
// 订单详情（通用H5物流）
export const getNewOrderInfo = ({ cToken = '', orderNumber }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/getOrderInfo`, { cToken, orderNumber });
};
// 重新预约物流单（通用H5物流）
export const replaceLogisticsOrder = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/OrderH5/replaceLogisticsOrder`, params);
};
// 快递公司列表（通用H5物流）
export const getNewExpressCompanyList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/common/getExpressCompanyList`);
};

// 轮播列表（活动-盲盒）
export const getBlindboxLoopList = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/getRollingList`, params);
};
// 查询中奖状态（活动-盲盒）
export const getBlindboxAwardDetails = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/getPrizeUserList`, params);
};
// 抽奖（活动-盲盒）
export const joinBlindboxAward = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/luck`, params);
};
// 解锁盲盒（活动-盲盒）
export const unlockBlindboxAward = (params = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/act/prizeDragon/changeStep`, params);
};
// 新机预约-SPU
export const getSpuList = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/ACT/PreSale/skuListBySpuId`, params);
};
// 新机预约-下单
export const orderBookeNew = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/ACT/PreSale/addOrder`, params);
};
// 新机预约-商品详情
export const getItemDetail = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/ACT/PreSale/index`, params);
};
// 新机预约-8城市列表
export const getXzCityList = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/common/getXzCityList`, params);
};
// 新机预约-我的预售列表
export const getMyPreOrder = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/ACT/PreSale/orderList`, params);
};
// 新机预约-预售详情
export const getPreOrderDetail = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/ACT/PreSale/orderDetail`, params);
};
// 校验登录态（v5）
export const checkTokenStatusV5 = (token) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/common/checkTokenStatus?token=${token}`);
};



// WEBPACK FOOTER //
// ./src/apis/hsbh5.js